<template>
    <div class="mo-mask" v-show="isVisible">
        <div class="mo-wrapper pos-rel">
            <div style="text-align: center; text-align: center; padding: 0px 20px; margin-bottom: 15px; margin-top: -15px; font-size: 22px;">{{title}}</div>
            <img class="mo-bg" src="../assets/img/p8.png" />
            <div class="mo-close" @click="this.isVisible=false">X</div>
            <div class="login" ref="content" style="min-height:300px; max-height:50vh; overflow-y:auto;padding:10px;">
                <div v-html="html" style="white-space:normal; text-justify:auto; text-wrap:normal; word-break:normal;">

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isVisible: false,
                title:"",
                html:""
            }
        },
        mounted() {},
        methods: {
            show(title,html) {
                this.isVisible = true;
                this.title = title;
                this.html = html;
            },
            hide() {
                this.isVisible = false;
            }
        }
    };
</script>


